import { render, staticRenderFns } from "./InventoryCreateModal.vue?vue&type=template&id=16523174&scoped=true&"
import script from "./InventoryCreateModal.vue?vue&type=script&lang=js&"
export * from "./InventoryCreateModal.vue?vue&type=script&lang=js&"
import style0 from "./InventoryCreateModal.vue?vue&type=style&index=0&id=16523174&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "16523174",
  null
  
)

export default component.exports